<template>
  <div class="flex content-section">
    <vk-offcanvas-content class="field-canvas">
      <vk-offcanvas flipped :show.sync="fieldConfig">
        <div class="flex">
          <vk-offcanvas-close @click="fieldConfig = false"></vk-offcanvas-close>
          <h3 class="font-medium text-lg">Gösterim Ayarları</h3>
        </div>
        <div v-if="fieldConfig" class="-medium-top">
          <vk-tabs align="justify">
            <vk-tabs-item title="Sıralama Kaydet">
              <form
                @submit.prevent="defaultSortSet()"
                class="flex border rounded-lg p-2 flex-col space-y-2"
              >
                <select v-model="sort.name" class="uk-select">
                  <option
                    v-for="fieldz in allFieldsFiltered"
                    class="uk-checkbox"
                    type="checkbox"
                    :value="fieldz"
                    :key="fieldz"
                    :disabled="fieldz == 'id'"
                  >
                    {{ getFieldDisplayName(fieldz) }}
                  </option>
                </select>
                <select v-model="sort.type" class="uk-select">
                  <option value="asc">Artan</option>
                  <option value="desc">Azalan</option>
                </select>
                <savebutton type="submit" title="Sıralayı kaydet" />
                <div class="text-xs">
                  Sıralamayı kaydettiğinizde listeleme sayfasında hep o sıralama
                  aktif olacaktır, bu ayar tarayıcınıza kayıt edilir.
                </div>
              </form>
            </vk-tabs-item>
            <vk-tabs-item title="Gösterim Düzeni">
              <vk-nav class="field-labels">
                <div class="flex mt-2 space-x-2">
                  <input
                    type="text"
                    placeholder="Arama"
                    class="uk-input rounded-lg "
                    v-model="fieldSearch"
                  />
                  <button class="green-button" @click="getData('Save')">
                    Kaydet
                  </button>
                </div>

                <label :key="field" v-for="field in allFieldsFiltered">
                  <input
                    class="uk-checkbox"
                    type="checkbox"
                    v-model="allFieldsCheckbox"
                    :value="field"
                    :disabled="field == 'id'"
                  />
                  {{ getFieldDisplayName(field) }}
                </label>
              </vk-nav>
            </vk-tabs-item>
            <vk-tabs-item
              v-if="allFieldsCheckbox"
              title="Gösterim Düzeni Sıralaması"
            >
              <button class="my-2 green-button w-full" @click="getData('Save')">
                Kaydet
              </button>

              <draggable v-model="allFieldsCheckbox" draggable=".drag">
                <div
                  :key="item"
                  class="
                    border-b
                    space-x-2
                    flex
                    items-center
                    justify-start
                    drag
                  "
                  v-for="item in allFieldsCheckbox"
                >
                  <div>
                    <vk-icon icon="list"></vk-icon>
                  </div>
                  <div>{{ getFieldDisplayName(item) }}</div>
                </div>
              </draggable>
            </vk-tabs-item>
          </vk-tabs>
        </div>
      </vk-offcanvas>
    </vk-offcanvas-content>

    <div class="w-full flex">
      <div
        v-if="sideBarShow"
        class="w-1/2 md:w-60 border-r absolute  md:relative bg-white z-20 md:-mt-4 pt-4  h-screen pr-2 text-sm mr-2"
      >
        <div class=" ">
          <form
            @submit="addFilters()"
            action="javascript:void(0)"
            class="flex flex-col space-y-2 w-full"
          >
            <div
              class="text-black flex justify-between items-center w-full font-medium"
            >
              <span class="flex-1">Detaylı Arama </span>
              <span
                class="md:opacity-0 block md:hidden float-right text-tile"
                @click="sideBarShow = false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M17.414 16L24 9.414L22.586 8L16 14.586L9.414 8L8 9.414L14.586 16L8 22.586L9.414 24L16 17.414L22.586 24L24 22.586z"
                  />
                </svg>
              </span>
            </div>
            <template v-if="filters.length > 0">
              <div class="flex flex-col  items-start  text-sm my-2">
                <span
                  class="
              border-b
              flex
              justify-between
              space-x-2
              items-center 
              w-full 
              text-xs
              py-1 
            "
                  :key="filter.value"
                  v-for="filter in filters"
                >
                  <template v-if="fieldsMap[filter.name]">
                    <div class="flex space-x-2">
                      <span
                        class="
                        flex
                        items-center
                        space-y-2
                        flex-col
                        cursor-pointer
                        justify-center
                        filter-edit
                      "
                      >
                      <vk-icon
                          icon="pencil"
                          class="  hover:text-green-600"
                          ratio="0.6"
                          @click="filterEdit(filter)"
                        ></vk-icon>
                        <vk-icon
                          icon="close"
                          ratio="0.6"
                          class="hover:text-red-600"
                          @click="filterRemove(filter)"
                        ></vk-icon>
                      </span>

                      <b>{{ fieldsMap[filter.name].display_name }}</b>
                    </div>
                  </template>

                  <div class="flex space-x-2 items-center">
                    <span class="filter-label">
                      {{ filterTypeName(filter.type, filter.value) }}
                    </span>
                    <span
                      class="
                        flex
                        items-center
                        cursor-pointer
                        justify-center
                        filter-close
                      "
                    >
                    </span>
                  </div>
                </span>
              </div>

              <VDropdown>
                <div
                  title="Filtreyi favorilere ekle"
                  class="text-tile inline-flex cursor-pointer border text-xs  items-center space-x-2 rounded-md border-tile-200 shadow-sm p-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 14 14"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="m9 13.5l-3.5-3l-3.5 3v-9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Z"
                      />
                      <path d="M5 .5h6a1 1 0 0 1 1 1v9" />
                    </g>
                  </svg>
                  <span>Aramayı favorilere ekle</span>
                </div>
                <!-- This will be the content of the popover -->
                <template #popper>
                  <form
                    @submit.prevent="favoriteFilter()"
                    class="p-2 text-xs flex space-x-2"
                  >
                    <input
                      type="text"
                      class="uk-input"
                      required
                      placeholder="Favori listeniz için bir isim"
                      v-model="favoriform.name"
                    />
                    <savebutton title="Kaydet" action="saveFormFavori" />
                  </form>
                </template>
              </VDropdown>
              <span v-if="filterForm.editedId" class="text-sm mb-2"
                >Arama Kriteri Düzeltme</span
              >
              <span v-else class="text-sm mb-2">Yeni Arama Kriteri</span>
            </template>

            <div v-if="fields">
              <select class="uk-select" v-model="filterForm.name">
                <option value="undefined" selected>Seçiniz</option>
                <option v-for="field in fields" :value="field.name">
                  {{ field.display_name }}
                </option>
              </select>
            </div>

            <div>
              <select
                class="uk-select"
                v-if="fieldsMap[filterForm.name]"
                v-model="filterForm.type"
              >
                <option
                  :value="filterv.id"
                  :key="filterv.id"
                  v-for="filterv in filterTypes"
                >
                  {{ filterv.value }}
                </option>
              </select>
            </div>

            <template v-if="filterForm.name">
              <template v-if="filterForm.type == 11 || filterForm.type == 12">
                <search-item
                  :form="filterForm"
                  :multiple="true"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
              <template
                v-else-if="
                  filterForm.type == 2 ||
                    filterForm.type == 3 ||
                    filterForm.type == 8 ||
                    filterForm.type == 9
                "
              >
                <input
                  type="text"
                  class="uk-input"
                  v-model="filterForm.value"
                  placeholder="Değer girin"
                />
              </template>
              <template v-else>
                <search-item
                  :form="filterForm"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
            </template>

            <div class="flex space-x-2">
              <savebutton
                action="addFilters"
                v-if="filterForm.editedId"
                title="Güncelle"
              />
              <savebutton action="addFilters" v-else title="Ara" />
              <span
                class="global-button cursor-pointer"
                v-if="filterForm.editedId"
                @click="filterForm = []"
                >iptal</span
              >
            </div>
          </form>
        </div>

        <FavoriteFilters :table="table" />
      </div>

      <div class="flex-1">
        <div class="flex  flex-1 w-full items-start space-x-2">
          <div class="md:w-5/6 flex  justify-start items-start space-x-2">
            <button @click="sideBarShow = !sideBarShow" class="">
              <span class="global-button" v-if="sideBarShow">
                <svg class="w-5 h-5" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="m14 18l-6-6l6-6l1.4 1.4l-4.6 4.6l4.6 4.6Z"
                  />
                </svg>
              </span>
              <span v-else class="global-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5 text-tile-500"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5q0-2.725 1.888-4.612T9.5 3q2.725 0 4.613 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3zM9.5 14q1.875 0 3.188-1.312T14 9.5q0-1.875-1.312-3.187T9.5 5Q7.625 5 6.313 6.313T5 9.5q0 1.875 1.313 3.188T9.5 14"
                  />
                </svg>
                <span class="hidden md:block">Detaylı Arama</span>
              </span>
            </button>

            <button @click="fieldConfigOpen()" class="global-button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-tile-500"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm9-2h2.5V6H13zm-4.5 0H11V6H8.5zM4 18h2.5V6H4zm13.5 0H20V6h-2.5z"
                />
              </svg>

              <span class="hidden md:block">Gösterim Ayarları</span>
            </button>

            <button
              @click="downloadExcel()"
              v-if="$root.cache.me.department == 'admin'"
              class="global-button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-tile-500"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm9-2h2.5V6H13zm-4.5 0H11V6H8.5zM4 18h2.5V6H4zm13.5 0H20V6h-2.5z"
                />
              </svg>

              <span class="hidden md:block">Export</span>
            </button>

            <button
              class="global-button"
              @click="inlineInsertFormModal = !inlineInsertFormModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-tile-500"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M13 14h2v-3h3V9h-3V6h-2v3h-3v2h3zm-7 4V2h16v16zm2-2h12V4H8zm-6 6V6h2v14h14v2zM8 4v12z"
                />
              </svg>

              <span class="hidden md:block">Ekle</span>
            </button>

            <select
              @change="setLimit()"
              v-model="limit"
              class="uk-select"
              style="max-width: 70px"
            >
              <option value>Seçiniz</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="250">250</option>
              <option value="500">500</option>
            </select>

            <template v-if="selection.length > 0 && permissions">
              <select
                v-model="bulkForm.type"
                class="uk-select"
                style="max-width: 100px"
              >
                <option value>Seçiniz</option>
                <option v-if="permissions.update == 1" value="1"
                  >Düzenle</option
                >
                <option v-if="permissions.delete == 1" value="2">Sil</option>
              </select>

              <div class="space-y-2" v-if="bulkForm.type == 1">
                <div class="border rounded-lg flex p-2 space-x-2">
                  <select
                    v-model="bulkForm.fieldName"
                    style="max-width: 200px"
                    class="uk-select"
                  >
                    <option value>Seçiniz</option>
                    <option
                      v-for="(name, fieldName) in tableHead"
                      :value="fieldName"
                      :key="fieldName"
                    >
                      <template v-if="fieldsMap[name]">{{
                        fieldsMap[name].display_name
                      }}</template>
                    </option>
                  </select>
                  <span v-if="bulkForm.fieldName && bulkForm.type == 1">
                    <form-item
                      v-if="fieldsMap[bulkForm.fieldName]"
                      :input="fieldsMap[bulkForm.fieldName]"
                      @changed="(g) => (bulkForm.fieldValue = g.value)"
                      :type="fieldsMap[bulkForm.fieldName].component.name"
                    />
                  </span>
                </div>
                <label
                  ><input
                    type="checkbox"
                    v-model="bulkForm.doubleUpdate"
                    value="1"
                    class="text-xs"
                  />
                  İkili atama</label
                >
                <div
                  v-if="bulkForm.doubleUpdate"
                  class="border rounded-lg flex p-2 space-x-2"
                >
                  <select
                    v-model="bulkForm.fieldName2"
                    style="max-width: 200px"
                    class="uk-select"
                  >
                    <option value>Seçiniz</option>
                    <option
                      v-for="(name, fieldName) in tableHead"
                      :value="fieldName"
                      :key="fieldName"
                    >
                      <template v-if="fieldsMap[name]">{{
                        fieldsMap[name].display_name
                      }}</template>
                    </option>
                  </select>
                  <span v-if="bulkForm.fieldName2 && bulkForm.type == 1">
                    <form-item
                      v-if="fieldsMap[bulkForm.fieldName2]"
                      :input="fieldsMap[bulkForm.fieldName2]"
                      @changed="(g) => (bulkForm.fieldValue2 = g.value)"
                      :type="fieldsMap[bulkForm.fieldName2].component.name"
                    />
                  </span>
                </div>
              </div>

              <span v-if="bulkForm.type == 1 && bulkForm.fieldName">
                <button
                  @click="bulkUpdate()"
                  type="submit"
                  class="global-button"
                >
                  Uygula
                </button>
              </span>
              <span v-if="bulkForm.type == 2">
                <button
                  @click="bulkRemove()"
                  type="submit"
                  class="   global-button"
                >
                  Sil
                </button>
              </span>   <span v-if="bulkForm.type == 2">
                <button
                  @click="bulkRemoveNotes()"
                  type="submit"
                  title="Lead ve müşteriye yazılmış notları topluca silmeyi sağlar"
                  alt="Lead ve müşteriye yazılmış notları topluca silmeyi sağlar"
                  class="   global-button"
                >
                   Notları Sil
                </button>
              </span>
            </template>
          </div>
          <div class="md:w-1/6 flex items-center justify-end space-x-2">
            <div v-if="permissions.excel_import == 1">
              <router-link :to="'/excel/' + table">
                <span
                  class=" global-button
            "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M4 4.735v14.53l10 1.429V3.306zM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zm-6.8-7l2.8 4h-2.4L9 13.714L7.4 16H5l2.8-4L5 8h2.4L9 10.286L10.6 8H13z"
                    />
                  </svg>
                  <span class="hidden md:block">Excel Yükle</span>
                </span>
              </router-link>
            </div>
          </div>
        </div>

        <template v-if="loading">
          <div class="root">
            <div class="no-results">
              <vk-spinner v-if="loading" ratio="4"></vk-spinner>
              <h2>Yükleniyor</h2>
              <h6>Yükleniyor lütfen bekleyin</h6>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="mt-4 min-h-screen rounded-lg">
            <form
              autocomplete="off"
              method="post"
              action="javascript:void(0)"
              @submit="multiSearch()"
            >
              <h3 class="total-records">
                Toplam Kayıt: {{ total }}
                <template v-if="page">, {{ page }} sayfa</template>
                <template v-if="selection">
                  <template v-if="selection.length > 0">
                    , Seçili kayıt sayısı: {{ selection.length }}
                  </template>
                </template>
              </h3>
              <table
                class="border rounded-lg uk-table uk-table-divider lead_table uk-table-hover"
              >
                <thead class="drop-shadow">
                  <tr class="drop-shadow">
                    <th class="thead-item  text-center mx-auto w-10">
                      <input
                        class="uk-checkbox"
                        type="checkbox"
                        v-model="select_all"
                        @click="selectAll(tableData)"
                      />
                    </th>
                    <th
                      class="thead-item"
                      :class="{ 'w-20': fieldName == 'ID' }"
                      :key="fieldName"
                      v-for="(name, fieldName) in tableHead"
                      @click="setSortItem(fieldName)"
                    >
                      <span class="flex items-center">
                        <template v-if="fieldName == sort.name">
                          <template v-if="fieldsMap[name]">
                            <span>{{ fieldsMap[name].display_name }}</span>
                          </template>
                          <template v-else>
                            <span>{{ name }}</span>
                          </template>

                          <template v-if="sort.type == 'desc'">
                            <vk-icon-link
                              reset
                              href="#"
                              icon="chevron-down"
                            ></vk-icon-link>
                          </template>
                          <template v-else>
                            <vk-icon-link
                              reset
                              href="#"
                              icon="chevron-up"
                            ></vk-icon-link>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="fieldsMap[name]">
                            <span>{{ fieldsMap[name].display_name }}</span>
                          </template>
                          <template v-else>
                            <span>{{ name }}</span>
                          </template>
                        </template>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="in-table-search">
                    <td class="text-center p-4">
                      <button
                        type="submit"
                        style="
                    background: none;
                    border: none;
                    margin: 0px;
                    margin-top:10px;
                    padding: 0px;
                  "
                      >
                        <vk-icon icon="search" />
                      </button>
                    </td>
                    <th
                      :key="fieldName"
                      :class="{ 'w-4': fieldName == 'id' }"
                      v-for="(name, fieldName) in tableHead"
                    >
                      <template
                        v-if="
                          fieldsMap[fieldName] && fieldsMap[fieldName].component
                        "
                      >
                        <search-item
                          :form="multiFilterItem"
                          @changed="
                            (gelen) =>
                              multiFilterFormAdd(gelen.value, fieldName)
                          "
                          :label="false"
                          v-model="multiFilterItem[fieldName]"
                          :input="fieldsMap[fieldName]"
                          :type="fieldsMap[fieldName].component.name"
                        />
                      </template>
                    </th>
                  </tr>
                  <tr v-if="total > 0" v-for="data in tableData" :key="data.id">
                    <td class="text-center">
                      <input
                        class="uk-checkbox"
                        type="checkbox"
                        v-model="selection"
                        :value="data.id"
                      />
                    </td>
                    <td
                      :class="{ 'w-4': fieldName == 'id' }"
                      v-for="(name, fieldName, index) in tableHead"
                      :key="index"
                    >
                      <row
                        :rowdata="data[fieldName]"
                        :rowall="data"
                        :fieldname="fieldName"
                        :table="table"
                        :inputs="fieldsMap[fieldName]"
                        :detailurl="detailurl"
                        :fieldtype="fieldName"
                      />
                    </td>
                  </tr>
                  <tr v-if="total == 0">
                    <td :colspan="Object.keys(tableHead).length + 1">
                      <div class="root">
                        <div class="no-results">
                          <svg
                            width="260"
                            height="140"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m188.93 118.333 19.063-12.415c2.031-1.317 3.263-3.562 3.247-5.949l-.147-24.706a6.8 6.8 0 0 0-3.32-5.803l-19.205-11.431c-2.27-1.351-5.146-1.29-7.404.165l-19.063 12.415c-2.031 1.318-3.263 3.562-3.247 5.949l.147 24.706a6.804 6.804 0 0 0 3.32 5.803l10.324 6.15 8.886 5.288c2.27 1.351 5.141 1.284 7.392-.167l.007-.005Z"
                              stroke="#99A2AF"
                              stroke-width="0.75"
                              stroke-miterlimit="10"
                            ></path>
                            <path
                              opacity="0.4"
                              d="M200.101 76.66 187.169 85c-1.55.976-3.54 1.016-5.09.09l-8.26-4.918-1.786-1.063-3.395-2.018-3.126-1.864a1.515 1.515 0 0 1-.754-1.315 1.579 1.579 0 0 1 .735-1.35l9.411-6.135-.005.023 7.071-4.607c1.53-.993 3.539-1.034 5.088-.108l15.253 9.085h-.03l1.299.768c.678.405.754 1.102.762 1.388.003.28-.064.983-.743 1.414l-3.519 2.283.021-.014Z"
                              stroke="#99A2AF"
                              stroke-width="0.75"
                              stroke-miterlimit="10"
                            ></path>
                            <g filter="url(#a)">
                              <rect
                                x="68.647"
                                y="17"
                                width="47.583"
                                height="47.583"
                                rx="9"
                                transform="rotate(45 68.647 17)"
                                stroke="#E16741"
                                stroke-width="0.75"
                              ></rect>
                            </g>
                            <rect
                              opacity="0.4"
                              x="68.647"
                              y="24.764"
                              width="36.602"
                              height="36.602"
                              rx="6"
                              transform="rotate(45 68.647 24.764)"
                              stroke="#E16741"
                              stroke-width="0.75"
                            ></rect>
                            <path
                              d="M71 44h-3.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C63 46.28 63 47.12 63 48.801v4.398c0 1.68 0 2.521.327 3.163a3 3 0 0 0 1.311 1.311C65.28 58 66.12 58 67.8 58h2.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C75 55.72 75 54.88 75 53.2V48m-4-4v2.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C71.76 48 72.04 48 72.6 48H75m-4-4 2 2 2 2"
                              stroke="#E16741"
                              stroke-width="0.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M94 25.017c13.861-7.838 30.626-10.65 47.354-6.637 16.729 4.013 30.394 14.124 39.191 27.397"
                              stroke="#E16741"
                              stroke-width="0.5"
                              stroke-linejoin="round"
                              stroke-dasharray="4 4"
                            ></path>
                            <path
                              opacity="0.5"
                              d="M66.914 95c8.927 13.186 22.691 23.162 39.459 27.01 16.767 3.848 33.504.871 47.286-7.104"
                              stroke="#99A2AF"
                              stroke-width="0.5"
                              stroke-linejoin="round"
                              stroke-dasharray="4 4"
                            ></path>
                          </svg>
                          <h2 class="text-lg font-semibold">
                            Kayıt Bulunamadı
                          </h2>
                          <h6 class="text-sm">
                            Kriterlerinize uyan bir kayıt bulunamadı
                          </h6>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 class="total-records">
                Toplam Kayıt: {{ total }}
                <template v-if="page">, {{ page }} sayfa</template>
              </h3>
            </form>
            <vk-pagination
              v-if="total > 0"
              :page.sync="page"
              v-on:update:page="getData('pageupdate')"
              :perPage="limit"
              :total="total"
            >
              <vk-pagination-page-prev></vk-pagination-page-prev>
              <vk-pagination-pages></vk-pagination-pages>
              <vk-pagination-page-next></vk-pagination-page-next>
            </vk-pagination>
          </div>
        </template>
      </div>
    </div>
    <vk-modal
      :stuck="true"
      class="editFormModal"
      :show.sync="inlineInsertFormModal"
    >
      <add-item
        :table="table"
        v-if="inlineInsertFormModal"
        type="insert"
        :inputs="fields"
        :header="'Ekle'"
        @after="
          getData('insert');
          inlineInsertFormModal = false;
        "
      />
    </vk-modal>

    <vk-modal :stuck="true" class="editFormModal" :show.sync="modalEditShow">
      <modal-edit
        :table="modalEdit.table"
        v-if="modalEditShow"
        :id="modalEdit.id"
      />
    </vk-modal>
    <vk-modal
      :stuck="true"
      class="permissionModal"
      :show.sync="modalPermissionShow"
    >
      <UserPermissionsVue
        :table="modalEdit.table"
        v-if="modalPermissionShow"
        :user_group="modalEdit.id"
      />
    </vk-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Row from "./Row";
import AddItemVue from "../Ui/AddItem.vue";
import httpService from "../../services/http";
import FormItemVue from "../Ui/FormItem.vue";
import SearchItemVue from "../Ui/SearchItem.vue";
import EventBus from "../Ui/EventBus";
import EditModalVue from "../../views/EditModal.vue";
import FavoriteFilters from "./FavoriteFilters";
import UserPermissionsVue from "../../views/UserPermissions";
export default {
  name: "data-table",
  props: {
    table: String,
    permissions: Array | Object,
    detailurl: String,
    tablename: String,
  },
  components: {
    Row,
    "form-item": FormItemVue,
    "search-item": SearchItemVue,
    draggable,
    "modal-edit": EditModalVue,
    "add-item": AddItemVue,
    UserPermissionsVue,
    FavoriteFilters,
  },
  data() {
    return {
      favoriform: {},
      storedFilterSave: false,
      favoriFormSave: false,
      defautSortParams: {},
      filterName: null,
      tabId: null,
      multiFilterItem: [],
      modalEditShow: false,
      inlineInsertFormModal: false,
      modalPermissionShow: false,
      leadDetailModal: false,
      modalEdit: [],
      filterTypes: [
        { id: 1, value: "Eşit olan" },
        { id: 2, value: "İçeren" },
        { id: 3, value: "İçermeyen" },
        { id: 4, value: "Büyük olan" },
        { id: 5, value: "Küçük olan" },
        { id: 6, value: "Büyük ve eşit olan" },
        { id: 7, value: "Küçük ve eşit olan" },
        { id: 8, value: "ile başlayan" },
        { id: 9, value: "ile biten" },
        { id: 10, value: "Arasındakiler" },
        { id: 11, value: "Birden fazla seçim" },
        { id: 12, value: "Birden fazla hariç tut" },
      ],
      loading: false,
      fields: {},
      bulkForm: {},
      bulkFormnew: null,
      fieldsMap: [],
      select_all: false,
      allFields: [],
      sideBarShow: false,
      fieldSearch: null,
      fieldConfig: false,
      page: null,
      limit: 15,
      total: 200,
      allFieldsCheckbox: [],
      sort: {
        type: "desc",
        name: "id",
      },
      filters: [],
      filterForm: {
        name: "",
        type: "",
        value: "",
      },
      tableHead: [],
      multiFilter: [],
      multiFilterStatus: false,
      tableData: [],
      selection: [],
      filterToEdit: null,
    };
  },
  created() {
    this.localStorageGet();

    if (this.$route.query.q) {
      this.filters = [{ type: 2, name: "name", value: this.$route.query.q }];
    }
    const urlParams = new URLSearchParams(window.location.search);
    let queryParams = false;
    urlParams.forEach((value, key) => {
      queryParams = true;

      this.multiFilterItem[key] = value;
      if (Number.isInteger(value)) {
        this.filters.push({ type: 1, name: key, value: value });
      } else {
        this.filters.push({ type: 2, name: key, value: value });
      }
    });

    if (queryParams) {
      this.getData("multiSearch");
    }

    this.getData("created");
  },

  watch: {
    filters: {
      deep: true, // Eğer filters nesnesi derin bir yapıdaysa, deep: true kullanılır.
      handler(newVal) {
        // filters değişkenindeki değişiklikler bu fonksiyonda ele alınır.
        localStorage.setItem(
          this.table + "_filters",
          JSON.stringify({ filters: newVal, sort: this.sort })
        );
      },
    },
    $route(to, from) {
      this.routeCleaner();
      if (this.$route.query.q) {
        this.filters = [{ type: 2, name: "name", value: this.$route.query.q }];
      }
      this.getData("watch");
    },
    allFieldsCheckbox(data) {
      localStorage.setItem(this.table + "_allFieldsCheckbox", data);
    },
  },

  computed: {
    tableFieldsArray() {
      return this.tableHead;
    },
    allFieldsFiltered() {
      if (this.fieldSearch) {
        return Object.keys(this.allFields).filter((post) => {
          return post.toLowerCase().includes(this.fieldSearch.toLowerCase());
        });
      } else {
        return this.allFields;
      }
    },
  },
  methods: {
    downloadExcel() {
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "info",
        title: "Lütfen bekleyin",
        duration: 2000,
        body: "Dosyalar hazırlanıyor lütfen bekleyin",
      });

      httpService
        .exportExcel(this.table, { filters: this.filters })
        .then((response) => {
          if (response.data.success && response.data.excelFiles.length > 0) {
            // Dosya isimlerini birleştirerek tek bir string haline getir
            let fileList = response.data.excelFiles.join("\n");
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "info",
              title: "Dosyalar hazır",
              body: fileList,
            });
          } else {
            alert("Dosya oluşturulamadı veya dosya yok.");
          }
        })
        .catch((error) => {
          console.error("İndirme hatası: ", error);
        });
    },
    favoriteFilterApply(data) {
      this.filters = data;
      this.getData("favoriteFilterApply");
    },
    favoriteFilter() {
      EventBus.$emit("loadingStatus", {
        action: "saveFormFavori",
        loading: true,
      });

      httpService
        .inlineSave({
          table: "favorite_filters",
          type: "insert",
          inputs: {
            name: this.favoriform.name,
            table: this.table,
            filters: JSON.stringify(this.filters),
          },
        })
        .then((e) => {
          this.favoriFormSave = false;
          this.favoriform.name = null;
          EventBus.$emit("loadingStatus", {
            action: "saveFormFavori",
            loading: false,
            success: true,
          });
          EventBus.$emit("reflesh", true);
        });
    },
    multiSearch() {
      const urlBuild = new URL(
        window.location.origin + window.location.pathname
      );

      this.filters = [];
      Object.keys(this.multiFilterItem).map((mp) => {
        if (this.multiFilterItem[mp]) {
          if (Number.isInteger(this.multiFilterItem[mp])) {
            this.filters.push({
              name: mp,
              value: this.multiFilterItem[mp],
              type: 1,
            });
          } else {
            if (mp == "name" || mp == "body") {
              this.filters.push({
                name: mp,
                value: this.multiFilterItem[mp],
                type: 2,
              });
            } else {
              this.filters.push({
                name: mp,
                value: this.multiFilterItem[mp],
                type: 1,
              });
            }
          }

          urlBuild.searchParams.append(mp, this.multiFilterItem[mp]);
        }
      });
      history.pushState("", "", urlBuild.href);

      this.getData("multiSearch");
    },
    routeCleaner() {
      this.sort =  {
        type: "desc",
        name: "id",
      };
      this.localStorageGet();
      this.selection = [];
      this.page = null;
      this.filterForm = [];
      this.filters = [];
      this.fieldsMap = [];
      this.tableData = [];
      this.tableHead = [];
      this.bulkForm = {};
      this.multiFilterItem = [];
    },
    getFieldDisplayName(key) {
      if (typeof this.fields === "object" && this.fields !== null) {
        let item = this.fields.find((e) => {
          return e.name == key;
        });

        if (item) {
          return item.display_name;
        }
      }
      return key;
    },
    filterTypeName(id, value) {
      let returntext = "";
      if (this.filterTypes.find((e) => e.id == id)) {
        returntext += this.filterTypes.find((e) => e.id == id).value;
      }
      if (id == 10) {
        return returntext + " : " + value.start + " : " + value.end;
      } else {
        return returntext + " : " + value;
      }
    },
    setLimit() {
      this.limit = parseInt(this.limit);
      this.getData("setLimit");
    },
    changedAction(e) {
      this.bulkForm.new = e;
    },
    bulkUpdate() {
      let updateState = true;
      this.bulkForm.ids = this.selection;
      this.bulkForm.table = this.table;
      if (this.bulkForm.doubleUpdate == true) {
        if (this.bulkForm.fieldName == this.bulkForm.fieldName2) {
          updateState = false;
          alert("Güncellenecek alanların ikiside aynı olmamalı");
        }
      }
      if (updateState) {
        this.loading = true;
        httpService
          .bulkSave(this.bulkForm)
          .then((e) => {
            setTimeout(() => {
              this.getData("bulkUpdate");
            }, 100);
          })
          .finally((e) => {
            this.loading = false;
          });
      }
    },
    bulkRemove() {
      if (confirm("Silinen kayıt geri getirelemez eminmisiniz ?")) {
        this.bulkForm.ids = this.selection;
        this.bulkForm.table = this.table;
        this.loading = true;
        httpService
          .bulkRemove(this.bulkForm)
          .then((e) => {
            setTimeout(() => {
              this.getData("bulkRemove");
            }, 100);
          })
          .finally((e) => {
            this.loading = false;
          });
      }
    },  bulkRemoveNotes() {
      if (confirm("Silinen notlar   geri getirelemez eminmisiniz ?")) {
        this.bulkForm.ids = this.selection;
        this.bulkForm.table = this.table;
        this.loading = true;
        httpService
          .bulkRemoveNotes(this.bulkForm)
          .then((e) => {
            setTimeout(() => {
              this.getData("bulkRemove");
            }, 100);
          })
          .finally((e) => {
            this.loading = false;
          });
      }
    },
    multiFilterFormValue(name) {
      if (name) {
        return Object.values(this.filters).find((e) => e.name == name);
      }
      return null;
    },
    multiFilterFormAdd(value, name) {
      this.multiFilterItem[name] = value;
    },
    localStorageGet() {
      if (this.$root.isMobile()) {
        if (this.table == "leads" || this.table == "customers") {
          this.allFieldsCheckbox = ["id", "name"];
        }
      } else {
        if (localStorage.getItem(this.table + "_allFieldsCheckbox")) {
          let ids = localStorage.getItem(this.table + "_allFieldsCheckbox");
          if (ids.substring(0, 3) == "id,") {
          } else {
            ids = "id," + ids;
          }
          this.allFieldsCheckbox = ids.split(",");
        } else {
          if (this.table == "leads" || this.table == "customers") {
            this.allFieldsCheckbox = [
              "id",
              "name",
              "status_id",
              "agent_id",
              "utm_source",
              "team_id",
            ];
          } else {
            this.allFieldsCheckbox = [];
          }
        }
      }
      if (localStorage.getItem(this.table + "_sortType")) {
        this.sort.type = localStorage.getItem(this.table + "_sortType");
        this.sort.name = localStorage.getItem(this.table + "_sortName");
      } else {
        //console.log("bulunamadı");
      }
    },
    filterRemove(item) {
      this.filters.splice(this.filters.indexOf(item), 1);
      this.getData("filterRemove");
    },
    addFilters() {
      if (this.filterForm.value) {
        if (this.filterForm.editedId) {
          this.filters.splice(this.filterForm.editedId - 1, 1);
        }

        this.filters.push(this.filterForm);
        this.filterForm = {
          name: "",
          type: "",
          value: "",
        };
        this.getData("addFilters");
      }
    },
    filterEdit(item) {
      this.filterToEdit = item;
      this.filterForm = { ...item };
      this.filterForm.editedId = this.filters.indexOf(item) + 1;
      //   this.filters.splice(this.filters.indexOf(item), 1);
    },
    fieldConfigOpen() {
      this.fieldConfig = true;
      if (!this.allFieldsCheckbox) {
        this.allFieldsCheckbox = [];
        Object.values(this.allFields).forEach((field) => {
          if (this.tableHead[field]) {
            this.allFieldsCheckbox.push(field);
          }
        });
      }
    },
    getData(methodName) {
      EventBus.$emit("loadingStatus", {
        action: methodName,
        loading: true,
      });

      this.$forceUpdate();

      this.loading = true;

      httpService
        .getData({
          table: this.table,
          page: this.page,
          sort: this.sort,
          filters: this.filters,
          limit: this.limit,
          fields: this.allFieldsCheckbox,
        })
        .then((response) => {
          this.fields = response.data.components;

          this.fields.map((field) => {
            this.fieldsMap[field.name] = field;
          });

          if (this.table == response.data.table) {
            this.tableData = response.data.results;
            this.total = 1 * response.data.total;
            if (response.data.page) {
              if (response.data.page > 0) {
                this.page = 1 * response.data.page + 1;
              } else {
                this.page = 0;
              }
            }
            EventBus.$emit("loadingStatus", {
              action: methodName,
              loading: false,
              success: true,
            });

            this.tableHead = response.data.fields;
            this.allFields = response.data.all_fields;
            this.tabId = response.data.tab_field_id;
            setTimeout(() => {
              this.loading = false;
            }, 100);
          } else {
            this.loading = true;
            this.tableData = this.allFields = this.tableHead = [];
          }
        })
        .catch(() => {
          console.log("yarıda kesildi");
        });
    },
    selectAll(checkboxs) {
      this.select_all = !this.select_all;
      if (this.select_all == true) {
        checkboxs.forEach((item) => {
          this.selection.push(item.id);
        });
      } else {
        this.selection = [];
      }
    },
    setSort(a) {
      this.sortType = a;
    },
    defaultSortSet() {
      localStorage.setItem(this.table + "_sortType", this.sort.type);
      localStorage.setItem(this.table + "_sortName", this.sort.name);
      this.getData("setSortItem");
    },
    setSortItem(a) {
      if (this.sort.type == "asc") {
        this.sort.type = "desc";
      } else {
        this.sort.type = "asc";
      }
      this.sort.name = a;

      this.getData("setSortItem");
    },
  },
  mounted() {
    this.localStorageGet();

    EventBus.$on("reflesh", () => {
      this.modalEditShow = false;
      this.modalPermissionShow = false;
      this.leadDetailModal = false;
      this.getData("reflesh");
    });
    EventBus.$on("favoriteFilterApply", (data) => {
      this.modalEditShow = false;
      this.modalPermissionShow = false;
      this.leadDetailModal = false;
      this.favoriteFilterApply(JSON.parse(data));
    });

    EventBus.$on("modalClose", () => {
      this.modalEditShow = false;
      this.modalPermissionShow = false;
      this.leadDetailModal = false;
    });
    EventBus.$on("editModalShow", (data) => {
      this.modalEdit.table = data.table;
      this.modalEdit.id = data.id;
      this.modalEditShow = true;
    });
    EventBus.$on("modalPermissionShow", (data) => {
      this.modalEdit.table = data.table;
      this.modalEdit.id = data.id;
      this.modalPermissionShow = true;
    });
    EventBus.$on("leadDetailModalShow", (data) => {
      this.modalEdit.id = data.id;
      this.leadDetailModal = true;
    });
  },
};
</script>
<style scoped>
.filter-item:hover .filter-close {
  @apply text-red-500;
}

.filter-item:hover .filter-edit {
  @apply text-blue-500;
}

.table-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f54a;
}

.table-scroll::-webkit-scrollbar {
  height: 4px;
  width: 4px;
  background-color: #f5f5f54a;
}

.table-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
}

.thead-item {
  cursor: pointer;
  padding: 4px 10px !important;
  text-overflow: ellipsis;
}
.thead-item:hover {
  @apply bg-pampas;
}

.thead-item {
  @apply align-middle truncate;
}

.navclass {
  margin-top: 15px;
  display: block;
}

.filtre-form {
  margin: 0px !important;
  padding-top: 10px;
}

.filters-ul {
  display: block;
  margin: 0px;
  padding: 0px;
}

.filters-ul .filter-label {
  font-size: 11px;
  display: block;
  clear: both;
  color: #ccc;
}

.filters-ul .filter-label:hover {
  color: #222;
}

.filters-ul li {
  display: block;
  border-bottom: 1px solid #eee;
  margin-bottom: 2px;
  min-height: 45px;
  padding: 3px;
}

.filters-ul li b {
  display: block;
  font-size: 11px;
  font-weight: normal;
  float: left;
}

.filters-ul .uk-icon {
  cursor: pointer;
}

.field-labels label {
  display: block;
  padding: 5px;
}

.table-name {
  margin-top: 20px;
}

.drag {
  padding: 10px;
  cursor: pointer;
}

.add-item-button {
  cursor: copy;
}

.table-header-nav {
  margin: 0px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  padding: 0px;
  align-items: center;
}

.table-header-nav .excel-import-li {
  align-self: flex-end;
  order: 7;
}

.table-header-nav li {
  display: block;
  align-items: flex-end;

  padding: 5px;
}

.table-header-nav li a {
  color: #222;
  display: block;
  padding: 10px;
  font-size: 12px;
}

.heightoverflow {
}

.total-records {
  margin: 0px;
  padding: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 13px;
  color: #999;
  text-transform: uppercase;
}

.filter-close {
  float: right;
}

.flex-row {
  display: flex;
  flex-direction: row;
  margin-left: -15px;
}

.selectedTr {
  background: #f7f8fb;
}

.w-overflow {
  @apply w-full overflow-x-scroll;
}
</style>
